var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_c('img',{staticClass:"image",attrs:{"src":_vm.getBrowser(_vm.environment.browser)}}),_vm._v(_vm._s(_vm._f("browser")(_vm.environment.browser)))])}
var staticRenderFns = []

export { render, staticRenderFns }